import { ThunkAction } from 'redux-thunk';
import * as Actions from './actions';
import { AnyAction } from 'redux';
import AuthService, { AuthServiceError } from '../../../utils/BkpAuthService';
import { AppState } from '../../store';
import { SignupMethod } from './types';

export const submitSignupForm = (): ThunkAction<Promise<void>, AppState, {}, AnyAction> => async (
  dispatch,
  getState
) => {
  dispatch(Actions.startToSignup());

  const { email, phoneNumber, signupMethod } = getState().signUpForm;

  try {
    // 電話番号 / メールアドレスのどちらで仮登録するか
    const data =
      signupMethod === SignupMethod.PhoneNumber
        ? await AuthService.preRegisterUserWithPhoneNumber(phoneNumber.value)
        : await AuthService.preRegisterUser(email.value);
    dispatch(Actions.signupSuccess(data));
  } catch (error) {
    dispatch(Actions.signupFailed(error === AuthServiceError.BKP_FAILED_ALREADY_EXIST ? 'already_exist' : 'internal'));
  }
};
